import './ScrollCue.css';
export default {
    "scrollCueContainer": "ScrollCue_scrollCueContainer__zu9if",
    "icon": "ScrollCue_icon__zu9if"
};
